import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Table, Button, Icon } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0% auto;
  
  background: #FFFFFF;
`;

export const Title =  styled.h1`
  width: 100%;
  max-width: 1100px;
  
  margin:0px auto 15px auto;
  padding-bottom: 5px;

  color:#000000;

  border-bottom: 1px solid rgba(0, 0, 0, .15);

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;
`;

export const SelectItemGeradorCertificado = styled.div`
  width:100%;
  height:100%;
  background-color: rgba(0,0,0,0.8);
  color:white;
  img{
    border:1px solid white;
  }
  display:flex;
  flex-direction:row;
  padding:10px;
  align-items:center;
`